import React from 'react';
import { Users, Trophy, Star, Target } from 'lucide-react';

const OranjePage = () => {
  const selectie = [
    { name: "Virgil van Dijk", position: "Verdediger", number: 4 },
    { name: "Memphis Depay", position: "Aanvaller", number: 10 },
    { name: "Frenkie de Jong", position: "Middenvelder", number: 21 },
    { name: "Cody Gakpo", position: "Aanvaller", number: 8 },
    { name: "Matthijs de Ligt", position: "Verdediger", number: 3 },
    { name: "Nathan Aké", position: "Verdediger", number: 5 }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-orange-600 to-amber-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">Oranje</h1>
            <p className="text-2xl mb-8 opacity-90">
              Volg het Nederlands elftal op weg naar de wereldtitel
            </p>
            <div className="grid grid-cols-3 gap-6">
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">8</div>
                <div className="text-sm">WK Deelnames</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">1</div>
                <div className="text-sm">Wereldtitels</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">3</div>
                <div className="text-sm">Finales</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Selectie</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {selectie.map((speler, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-4">
                    {speler.number}
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">{speler.name}</h3>
                    <p className="text-gray-600 text-sm">{speler.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OranjePage;